import styled from 'react-emotion';

export default styled('div')`
  margin-bottom: ${props => `${props.size}px`};
`;
